module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAWCAYAAADTlvzyAAAANElEQVRIiWM07f//n4GOgImeljGMWkgLwILDTEZaWTiaaEYtHLVw1MJRC0ctHPEWMjAwAAC2+gLxLmuTlgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/border_1.png
// module id = Tsa1
// module chunks = 1